import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LinkService } from '../link.service';

@Injectable({ providedIn: 'root' })
export class DwellTimeService {
  static readonly DEFAULT_MS = 1500;

  private readonly _ms$ = new BehaviorSubject<number>(DwellTimeService.DEFAULT_MS);
  readonly ms$ = this._ms$.asObservable();

  /**
   * Resolves once the persisted value has been hydrated from storage.
   * Await this before reading `current` so the UI never shows a stale default.
   */
  readonly ready: Promise<void>;

  constructor(private link: LinkService) {
    // Hydrate eagerly on first injection so `current` reflects the persisted
    // value even on screens that never start the gaze cursor (welcome, landing…).
    this.ready = this.init();
  }

  async init(): Promise<void> {
    const ms = await this.link.getDwellTime(); // Preferences
    this._ms$.next(ms);
  }

  async set(ms: number): Promise<void> {
    const clamped = Math.min(4000, Math.max(400, Math.round(ms)));
    this._ms$.next(clamped);
    await this.link.setDwellTime(clamped);
  }

  get current(): number {
    return this._ms$.value;
  }
}